export default {
      id: "ic-misc-calendar-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic-misc-calendar-usage",
      toString: function () {
        return this.url;
      }
    }